var map = {
	"./antofagasta.jpg": 798,
	"./araucania.jpg": 799,
	"./arica_y_parinacota.jpg": 800,
	"./atacama.jpg": 801,
	"./aysen.jpg": 802,
	"./biobio.jpg": 803,
	"./coquimbo.jpg": 804,
	"./los_lagos.jpg": 805,
	"./los_rios.jpg": 806,
	"./magallanes.jpg": 807,
	"./maule.jpg": 808,
	"./metropolitana.jpg": 809,
	"./nacional.jpg": 810,
	"./nuble.jpg": 811,
	"./ohiggins.jpg": 812,
	"./tarapaca.jpg": 813,
	"./valparaiso.jpg": 814
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 797;